import { render, staticRenderFns } from "./MerchantDetails.vue?vue&type=template&id=3ebe05a0&scoped=true&"
import script from "./MerchantDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantDetails.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDetails.vue?vue&type=style&index=0&id=3ebe05a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe05a0",
  null
  
)

export default component.exports